import React from 'react';
import PropTypes from 'prop-types';
import './SmartAlertLineItem.styl';

export default class SmartAlertLineItem extends React.PureComponent {
  render() {
    const {label, children} = this.props;
    return (
      <div className="smart-alert-line-item">
        <label>{label}</label>
        <div className="item-right">{children}</div>
      </div>
    );
  }
}

SmartAlertLineItem.propTypes = {
  label: PropTypes.string.isRequired,
  children: PropTypes.node,
};
